class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

this.addEventListener('click', (event) => {
  if (
    event.target.closest('.drawer__close') ||
    event.target.closest('#CartDrawer-Overlay')
  ) {
    event.preventDefault();
    this.close();
  }
});

this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
  event.preventDefault();
  window.__cartDrawerForceClosedUntil = 0;
  this.classList.remove('force-closed');
  this.open(cartLink);
});
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
  if (window.__cartDrawerForceClosedUntil && Date.now() < window.__cartDrawerForceClosedUntil) {
    return;
  }

  this.classList.remove('force-closed');
  this.classList.add('animate', 'active');
});
   
    const overlay = this.querySelector('#CartDrawer-Overlay');
if (overlay) {
  overlay.style.pointerEvents = 'auto';
}
    this.addEventListener(
  'transitionend',
  () => {
    if (!this.classList.contains('active')) return;

    const containerToTrapFocusOn = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');

    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

    if (containerToTrapFocusOn && focusElement) {
      trapFocus(containerToTrapFocusOn, focusElement);
    }
  },
  { once: true }
);

    document.body.classList.add('overflow-hidden');
  }

close() {
  window.__cartDrawerForceClosedUntil = Date.now() + 2000;

  this.classList.add('force-closed');
  this.classList.remove('active');
  this.classList.remove('animate');

  try {
    removeTrapFocus(this.activeElement || document.activeElement);
  } catch (e) {
    console.warn('removeTrapFocus failed:', e);
  }

  const cleanup = () => {
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-mobile');
    document.documentElement.classList.remove('overflow-hidden');

    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.style.pointerEvents = 'none';
    }

    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.removeAttribute('tabindex');
    }
  };

  cleanup();
  setTimeout(cleanup, 50);
  setTimeout(cleanup, 300);
}

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    
    setTimeout(() => {
  if (window.__cartDrawerForceClosedUntil && Date.now() < window.__cartDrawerForceClosedUntil) {
    return;
  }

  this.open();
});
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
window.forceResetCartDrawerState = function () {
  window.__cartDrawerForceClosedUntil = Date.now() + 3000;

  document.querySelectorAll('cart-drawer').forEach(function (drawer) {
    drawer.classList.add('force-closed');
    drawer.classList.remove('active');
    drawer.classList.remove('animate');

    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.style.pointerEvents = 'none';
    }
  });

  document.body.classList.remove('overflow-hidden');
  document.body.classList.remove('overflow-hidden-tablet');
  document.body.classList.remove('overflow-hidden-mobile');
  document.documentElement.classList.remove('overflow-hidden');

  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
};

function forceCartDrawerCloseForAWhile() {
  window.__forceCartDrawerClosingUntil = Date.now() + 3000;

  [0, 50, 100, 200, 500, 1000, 2000, 3000].forEach(function (delay) {
    setTimeout(function () {
      if (window.forceResetCartDrawerState) {
        window.forceResetCartDrawerState();
      }
    }, delay);
  });
}

document.addEventListener(
  'pointerdown',
  function (event) {
    if (
      event.target.closest('.drawer__close') ||
      event.target.closest('#CartDrawer-Overlay')
    ) {
      forceCartDrawerCloseForAWhile();
    }
  },
  true
);

document.addEventListener(
  'click',
  function (event) {
    if (
      event.target.closest('.drawer__close') ||
      event.target.closest('#CartDrawer-Overlay')
    ) {
      event.preventDefault();
      forceCartDrawerCloseForAWhile();
    }
  },
  true
);

document.addEventListener('keyup', function (event) {
  if (event.code === 'Escape') {
    forceCartDrawerCloseForAWhile();
  }
});

setInterval(function () {
  if (window.__forceCartDrawerClosingUntil && Date.now() < window.__forceCartDrawerClosingUntil) {
    if (window.forceResetCartDrawerState) {
      window.forceResetCartDrawerState();
    }
  }
}, 100);